// extracted by mini-css-extract-plugin
export var parcelRow = "_uz-0";